import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'

const StyledText = styled(BodyText)`
  margin-top: auto;
`

interface Props {
  availableForPurchase: boolean;
  hasPrice: boolean;
}

function FlashTourSoldOutOrUnavailable(props: React.PropsWithChildren<Props>) {
  const { availableForPurchase, children, hasPrice } = props
  if (availableForPurchase && hasPrice) {
    return <>{children}</>
  }

  const message = availableForPurchase ? 'unavailable' : 'Sold out'

  return (
    <StyledText variant="large">
      {message}
    </StyledText>
  )
}

export default FlashTourSoldOutOrUnavailable
